// extracted by css-extract-rspack-plugin
export default {"mobileTipContent":"mobile-tip-content--T1g5I9_4WU84NqvX"};